// Import external
import { Component, Input } from '@angular/core';

// Import internal
import { GravatarService } from '@app/services/gravatar.service';
import { EmbeddedUser } from '@data/models/embed.model';
import { User } from '@data/models/user.model';

@Component({

    selector: 'syn-user-avatar',
    templateUrl: 'user-avatar.component.html',
    styleUrls: ['user-avatar.component.scss']
})
export class UserAvatarComponent {
    @Input() user: User;
    @Input() titleInfos = '';
    @Input() showLegend = false;
    @Input() showId = false;
    @Input() caption = '';
    @Input() size = 32;
    @Input() legend = '';
    @Input() clickable = true;
    @Input() tooltip = false;
    @Input() backgroundColor: string;
    @Input() iconColor: string;

    constructor(private gravatarService: GravatarService) { }

    public get avatarIco(): string {
        return this.user.deletedAt ? 'account-off-outline' : this.user.avatar ? this.user.avatar : this.gravatarService.getGravatarUri(this.user.email, this.size);
    }

    public get name(): string {
        return (this.user instanceof EmbeddedUser) ? this.user.fullName : this.user.name || (this.user.firstName + ' ' + this.user.lastName);
    }

    public get title(): string {
        const legend = this.legend || this.name;
        return this.titleInfos ? legend + ' (' + this.titleInfos + ')' : legend;
    }

    public get text(): string {
        return !this.showLegend ? this.showId ? this.user.id : '' : this.name;
    }

    public get link(): string {
        return `/users/${this.user.id}`;
    }

    public get textColor(): string {
        return this.user?.deletedAt ? 'var(--clara-red)' : 'var(--clara-black)';
    }
}
